module.exports = __webpack_public_path__ + "static/baywatch-e83da678ab50a232bc95bc9d233bbbf4.png";